import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";
import { dashboardStats, dadosMensais } from "@/mocks/dashboard";

const { especiesMaisFrequentes } = dashboardStats;

export function EspeciesChart() {
  const data = especiesMaisFrequentes.map((e) => ({
    name: e.comum,
    Quantidade: e.quantidade,
  }));

  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Espécies Mais Frequentes</h3>
      <div className="h-[220px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: 10, right: 10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E8EAED" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 11, fill: "#6B737A" }} axisLine={false} />
            <YAxis
              type="category"
              dataKey="name"
              tick={{ fontSize: 11, fill: "#454B50" }}
              width={85}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip
              formatter={(value: number) => value.toLocaleString("pt-BR")}
              contentStyle={{
                borderRadius: "8px",
                border: "1px solid #E8EAED",
                fontSize: "12px",
              }}
            />
            <Bar dataKey="Quantidade" fill="#1B6E4F" radius={[0, 4, 4, 0]} barSize={20} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export function MonthlyTrend() {
  return (
    <div className="bg-white rounded-card border border-background-200 p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">Evolução Mensal</h3>
      <div className="h-[220px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={dadosMensais} margin={{ top: 5, right: 10, left: 10, bottom: 0 }}>
            <defs>
              <linearGradient id="colorArvores" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#1B6E4F" stopOpacity={0.15} />
                <stop offset="95%" stopColor="#1B6E4F" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="colorVistorias" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#0052CC" stopOpacity={0.15} />
                <stop offset="95%" stopColor="#0052CC" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E8EAED" />
            <XAxis dataKey="mes" tick={{ fontSize: 11, fill: "#6B737A" }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: "#6B737A" }} axisLine={false} tickLine={false} width={40} />
            <Tooltip
              contentStyle={{
                borderRadius: "8px",
                border: "1px solid #E8EAED",
                fontSize: "12px",
              }}
            />
            <Area
              type="monotone"
              dataKey="arvores"
              stroke="#1B6E4F"
              fill="url(#colorArvores)"
              strokeWidth={2}
              name="Árvores Cadastradas"
            />
            <Area
              type="monotone"
              dataKey="vistorias"
              stroke="#0052CC"
              fill="url(#colorVistorias)"
              strokeWidth={2}
              name="Vistorias"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}